import PropTypes from 'prop-types';
import Select from 'react-select';


const CustomSelectSimple = ({ options, value, onChange, placeholder, isMulti,  isDisabled, extraClass, label, name, ...props}) => {
  return (
    <div className={`container-select ${extraClass} `}>
      {label && <label>{label}</label>}
      <Select
        options={options}
        value={value}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        isMulti={isMulti}
        isDisabled={isDisabled}
        {...props}
      />
    </div>
  )
}

CustomSelectSimple.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  onChange: PropTypes.func,
  value: PropTypes.any,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

export default CustomSelectSimple





